import { StatusConfigKey } from '../enums/status-config-key.enum';
import { RequestUserStatus } from 'src/app/model/enum/request-user-status.enum';

export const ALL_STATUS_CONFIGS_KEYS: StatusConfigKey[] = Object.values(StatusConfigKey) as StatusConfigKey[];

export const STATUS_CONFIG_KEY_TO_STATUSES: { [key in StatusConfigKey]: RequestUserStatus[] } = {
    [StatusConfigKey.Gray]: [RequestUserStatus.Draft, RequestUserStatus.Reopened],
    [StatusConfigKey.Blue]: [RequestUserStatus.Submitted, RequestUserStatus.FollowupSubmitted],
    [StatusConfigKey.DarkGray]: [RequestUserStatus.PendingFollowUp],
    [StatusConfigKey.Red]: [RequestUserStatus.FollowUpExpired],
    [StatusConfigKey.Green]: [RequestUserStatus.Approved, RequestUserStatus.Completed, RequestUserStatus.FollowupForgiven],
    [StatusConfigKey.Black]: [RequestUserStatus.Disapproved, RequestUserStatus.Cancelled],
    [StatusConfigKey.Yellow]: [RequestUserStatus.FollowupExpiring]
};

export const STATUS_CONFIG_KEY_CONFIG: { key: StatusConfigKey, label: string; class: string }[] = [
    { key: StatusConfigKey.Gray, label: 'Draft / Reopened', class: 'status-circle--gray' },
    { key: StatusConfigKey.Blue, label: 'Submitted', class: 'status-circle--blue' },
    { key: StatusConfigKey.DarkGray, label: 'Pending Follow-Up', class: 'status-circle--darkgray' },
    { key: StatusConfigKey.Yellow, label: 'Follow-Up Expiring', class: 'status-circle--yellow' },
    { key: StatusConfigKey.Red, label: 'Follow-Up Expired', class: 'status-circle--red' },
    { key: StatusConfigKey.Green, label: 'Completed / Follow-Up Forgiven', class: 'status-circle--green' },
    { key: StatusConfigKey.Black, label: 'Disapproved / Cancelled', class: 'status-circle--black' }
];
